// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';


const styledComponentsConfig = {};
export function rootContainer(container) {
  const scConfig =
    typeof styledComponentsConfig === 'function'
      ? styledComponentsConfig()
      : styledComponentsConfig;
  const globalStyle = scConfig.GlobalStyle ? <scConfig.GlobalStyle /> : null;
  const inner = (
    <>
      {globalStyle}
      {container}
    </>
  );
  return inner;
}
